import { rtwClient } from 'src/services/apiService';
import type { Modification, ModificationWithRegionsAndTasksDTO } from 'src/services/modification/types';
import type { ServiceOptions } from 'src/types';

// **** Functions **** //

/**
 * Get modifications
 */
async function getModifications(options?: ServiceOptions) {
  const res = await rtwClient.get<Modification[]>('/modifications', { signal: options?.signal });
  return res.data;
}

/**
 * Get modifications
 */
async function getModificationWithRegionsAndTasksDTOList() {
  const res = await rtwClient.get<ModificationWithRegionsAndTasksDTO[]>(
    '/modifications/modificationWithRegionsAndTasksDTOList',
  );
  return res.data;
}

/**
 * Create or update modification
 */
async function createOrUpdateModifications(payload: Modification) {
  const res = await rtwClient.post<Modification>('/modifications', payload);
  return res.data;
}

/**
 * Delete modification
 */
async function deleteModification(modificationId: number) {
  await rtwClient.delete(`/modifications/${modificationId}`);
}

// **** Export **** //

export default {
  getModifications,
  getModificationWithRegionsAndTasksDTOList,
  createOrUpdateModifications,
  deleteModification,
} as const;
